<template>
  <svg :width="`calc(40 / 18 * ${size})`" :height="size" viewBox="0 0 40 18" fill="none" v-on="$listeners">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M37.5996 0C34.2561 6.5296 27.4499 11 19.5996 11C11.7494 11 4.94311 6.5296 1.59961 0H5.47168C6.81334 2.07851 8.60732 3.84265 10.7256 5.16602C13.3763 6.82071 16.4557 7.69919 19.6006 7.69922C22.7454 7.69922 25.8249 6.82065 28.4756 5.16602C30.5938 3.84266 32.3878 2.07849 33.7295 0H37.5996Z" :fill="color"/>
    <path d="M5.84961 4L1.34961 7.5" :stroke="color" stroke-width="2.7" stroke-linecap="round"/>
    <path d="M33.3496 4L37.8496 7.5" :stroke="color" stroke-width="2.7" stroke-linecap="round"/>
    <path d="M27.0839 8.33591L30.1154 13.1639" :stroke="color" stroke-width="2.7" stroke-linecap="round"/>
    <path d="M12.5782 8.99997L9.54668 13.828" :stroke="color" stroke-width="2.7" stroke-linecap="round"/>
    <path d="M19.1223 10.0001L19.1063 15.701" :stroke="color" stroke-width="2.7" stroke-linecap="round"/>
  </svg>
</template>


<script>
export default {
  name: 'IconEyeClose',

  props: {
    size: {
      type: String,
      default: '1em',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>